/**
 * Юр. документы на лендинге: для UI не-ru текст оферты/политики только EN (см. landing DocSwitch).
 * Внешние абсолютные URL дополняем ?lang=en, чтобы при открытии в браузере сработал query в i18n.
 */

export const BECLIENTS_VK_LEGAL_OFFER_URL = 'https://vk.com/@beclients-offer';
export const BECLIENTS_VK_LEGAL_PRIVACY_URL = 'https://vk.com/@beclients-privacy';

export function withLandingLegalLang(absoluteUrl: string, uiLanguage: string | undefined): string {
  const loc = (uiLanguage ?? 'ru').split('-')[0].toLowerCase();
  if (loc === 'ru') return absoluteUrl;
  try {
    const u = new URL(absoluteUrl);
    u.searchParams.set('lang', 'en');
    return u.toString();
  } catch {
    const sep = absoluteUrl.includes('?') ? '&' : '?';
    return `${absoluteUrl}${sep}lang=en`;
  }
}

/** Web / VK Mini App: статьи ВК только при русском UI; иначе лендинг с EN-текстом. */
export function offerPrivacyUrlsForApp(opts: {
  landingBaseUrl: string;
  uiLanguage: string | undefined;
  preferVkHostedLegalWhenRussian: boolean;
}): { offerUrl: string; privacyUrl: string } {
  const base = opts.landingBaseUrl.replace(/\/$/, '');
  const loc = (opts.uiLanguage ?? 'ru').split('-')[0].toLowerCase();
  if (opts.preferVkHostedLegalWhenRussian && loc === 'ru') {
    return {
      offerUrl: BECLIENTS_VK_LEGAL_OFFER_URL,
      privacyUrl: BECLIENTS_VK_LEGAL_PRIVACY_URL,
    };
  }
  return {
    offerUrl: withLandingLegalLang(`${base}/offer`, opts.uiLanguage),
    privacyUrl: withLandingLegalLang(`${base}/privacy`, opts.uiLanguage),
  };
}

/** Путь для React Router / ссылок на лендинге: не-ru → ?lang=en (оферта). */
export function landingOfferPathForLocale(locale: string): string {
  const loc = locale.split('-')[0].toLowerCase();
  return loc === 'ru' ? '/offer' : '/offer?lang=en';
}

/** Путь политики для локали. */
export function landingPrivacyPathForLocale(locale: string): string {
  const loc = locale.split('-')[0].toLowerCase();
  return loc === 'ru' ? '/privacy' : '/privacy?lang=en';
}
